export default "__VITE_ASSET__x3axdJst__"